import React from 'react';
import { Modal, Form } from 'antd';
import { useQueryClient } from 'react-query';
import FormBlock from './components/FormBlock';
import useBindTenantToRoomMutation from '../../../mutations/useBindTenantToRoomMutation';
import { roomQueryKeys } from '../../../queries/queryKeys';
import useEditRoomTenantMutation from '../../../mutations/useEditRoomTenantMutation';

const AddTenantToRoom = ({
  form,
  onCancel,
  visible,
  initialValues,
  roomId,
}) => {
  const { resetFields, validateFieldsAndScroll } = form;

  const queryClient = useQueryClient();

  const handleCancel = () => {
    resetFields();

    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  const onSuccess = () => queryClient.invalidateQueries(roomQueryKeys(roomId));

  const { mutateAsync: bindTenantMutateAsync, isLoading: isBindTenantLoading } =
    useBindTenantToRoomMutation({ onSuccess });

  const { mutateAsync: editTenantMutateAsync, isLoading: isEditTenantLoading } =
    useEditRoomTenantMutation({ onSuccess });

  const modalText = Boolean(initialValues) ? 'Изменить' : 'Добавить арендатора';

  const handleSubmit = () => {
    validateFieldsAndScroll(async (err, fieldValues) => {
      if (!err) {
        const values = {
          ...fieldValues,
          officeId: roomId,
          account: fieldValues.account.trim(),
          startDate: fieldValues.startDate.utc().format(),
        };

        initialValues
          ? await editTenantMutateAsync({ values })
          : await bindTenantMutateAsync({ values });

        handleCancel();
      }
    });
  };

  return (
    <Modal
      visible={visible}
      title={modalText}
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText={modalText}
      destroyOnClose
      confirmLoading={isBindTenantLoading || isEditTenantLoading}
    >
      <FormBlock form={form} initialValues={initialValues} />
    </Modal>
  );
};

const AddTenantToRoomModal = Form.create({ name: 'add_tenant_to_room' })(
  AddTenantToRoom
);

export default AddTenantToRoomModal;
